import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'
import {
  EXPERIMENT_FLAG,
  type GiftHeroCardBucket,
  type GiftHeroCards,
  VARIANT_1_HERO_CARDS,
} from '../constants'

export const useGiftHeroCards = ({
  control,
  isPromoHeroOverride,
}: {
  control: GiftHeroCards
  isPromoHeroOverride: boolean
}): GiftHeroCards => {
  const bucket = useBucket<GiftHeroCardBucket>(EXPERIMENT_FLAG)

  useEffect(() => {
    if (bucket && !isPromoHeroOverride) {
      trackExperimentViewed(EXPERIMENT_FLAG)
    }
  }, [bucket, isPromoHeroOverride])

  if (bucket === 'variant_1' && !isPromoHeroOverride) {
    return VARIANT_1_HERO_CARDS
  }

  return control
}
